import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PartnerCTASection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section ref={ref} className={`scroll-reveal ${revealed ? 'revealed' : ''}`}>
      <div className="grid grid-cols-1 lg:grid-cols-2">
        {/* Left: Warehouse/Transport Partner */}
        <div className="bg-brand-700 px-8 py-16 md:px-16 md:py-20 flex flex-col justify-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.03]"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff'%3E%3Cpath d='M0 20L20 0l20 20-20 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
          <div className="relative z-10">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-paper-50 mb-4">
              Own a warehouse or reefer van?
            </h2>
            <p className="text-brand-200/90 mb-8 max-w-md leading-relaxed">
              Turn idle capacity into income. List your facility or vehicle on India&apos;s largest frozen-capacity network.
            </p>
            <Link
              to="/storage"
              className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Become a Capacity Partner
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Right: Buyer Partner */}
        <div className="bg-accent-500 px-8 py-16 md:px-16 md:py-20 flex flex-col justify-center relative overflow-hidden">
          <div className="absolute inset-0 opacity-[0.05]"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000'%3E%3Cpath d='M20 0l20 20-20 20L0 20z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            }}
          ></div>
          <div className="relative z-10">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-800 mb-4">
              Run a hotel, restaurant or retail business?
            </h2>
            <p className="text-brand-800/80 mb-8 max-w-md leading-relaxed">
              Source frozen seafood, meat, and vegetables at scale — with standardised specs and consistent quality you can trust.
            </p>
            <Link
              to="/wholesale"
              className="inline-flex items-center gap-2 px-7 py-3 bg-brand-700 hover:bg-brand-800 text-paper-50 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Become a Buyer
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}